import banner from "./banner.jpg"
import logo from "./logo.jpg"

const shop = {
    id: "shop006",
  
    vendorId: "i5qjnT9GaPfw1xmLlPWLuYxCSaD3",
  
    slug: "dominos-pizza",
  
    name: "DominoGÇÖs Pizza",
  
    category: "food",
  
    rating: 4.5,
  
    deliveryTime: "20-30 mins",
  
    featured: true,
  
    logo: logo,
  
    banner: banner,

    size: "small",

    products: [],

    location: "Abuja",

    deliveryPricing: {
      baseFee: 500,
      perKm: 180
    },

    location2: {
      area: "Wuse 2",
      city: "Abuja",
    
      coordinates: {
        lat: 9.0765,
        lng: 7.3986
      }
    },
   
  };
  
  export default shop;